import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function multipleHyphensValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as string;

    if (value && /--+/.test(value)) {
      return { multipleHyphens: true };
    }

    return null;
  };
}
